export default __webpack_public_path__ + "static/media/logout.559572a1.svg";